export default __webpack_public_path__ + "static/media/026-warning.869b21b1.png";